var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleColored(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none",
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 24,
    height: 25,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.77 9.973H12.256v4.708h6.616a5.64 5.64 0 0 1-2.099 3.522c-1.52 1.19-3.294 1.433-4.525 1.433-3.111 0-5.769-2.052-6.798-4.84-.041-.1-.069-.205-.103-.308a7.33 7.33 0 0 1 .029-4.568c.967-2.898 3.685-5.063 6.874-5.063.641 0 1.259.078 1.845.233a6.6 6.6 0 0 1 2.865 1.608L20.461 3.2C18.331 1.207 15.556 0 12.244 0a12.26 12.26 0 0 0-10.95 6.756A12.1 12.1 0 0 0 0 12.244c0 1.982.459 3.844 1.295 5.492v.01a12.4 12.4 0 0 0 3.745 4.405 12.17 12.17 0 0 0 7.204 2.339c1.94 0 3.66-.357 5.176-1.026a10.6 10.6 0 0 0 2.941-1.921 10.8 10.8 0 0 0 2.688-3.912c.62-1.521.951-3.241.951-5.106 0-.868-.085-1.75-.23-2.552"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M-.176 12.327c.012 1.95.557 3.963 1.381 5.588v.01c.596 1.18 1.41 2.113 2.338 3.036l5.6-2.085c-1.06-.55-1.221-.886-1.98-1.5a7.26 7.26 0 0 1-1.716-2.791h-.014l.014-.011c-.237-.71-.26-1.464-.269-2.247z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M12.256-.09c-.554 1.985-.342 3.914 0 5.037.639 0 1.255.078 1.839.233a6.6 6.6 0 0 1 2.865 1.608L20.55 3.2c-2.126-1.99-4.686-3.286-8.294-3.29"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M12.244-.105a12.52 12.52 0 0 0-7.277 2.322 12.6 12.6 0 0 0-2.086 1.864c-.163 1.563 1.222 3.484 3.966 3.468 1.332-1.58 3.3-2.602 5.492-2.602h.006l-.09-5.051z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "m21.206 12.893-2.424 1.699a5.64 5.64 0 0 1-2.099 3.522c-1.517 1.187-3.285 1.431-4.517 1.432-1.272 2.212-1.495 3.32.09 5.104 1.961-.002 3.7-.363 5.234-1.04a10.7 10.7 0 0 0 2.98-1.946 11 11 0 0 0 2.724-3.964c.628-1.542.964-3.285.964-5.175z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3086ff",
    d: "M12.077 9.794v5.066h11.66c.103-.694.442-1.592.442-2.335 0-.868-.085-1.929-.23-2.73z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M2.937 3.902a12.2 12.2 0 0 0-1.822 2.675C.279 8.24-.179 10.262-.179 12.244l.002.083c.37.725 5.116.586 5.355 0l-.003-.081c0-.813.134-1.412.38-2.147a7.5 7.5 0 0 1 1.382-2.46c.137-.18.504-.564.61-.795.041-.087-.073-.137-.08-.168-.007-.034-.16-.006-.195-.032-.11-.082-.326-.125-.457-.163-.281-.081-.747-.26-1.006-.446-.817-.586-2.093-1.287-2.872-2.133"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M5.827 6.68c1.896 1.172 2.44-.592 3.701-1.144L7.336.896A12.3 12.3 0 0 0 2.3 4.882z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#o)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M6.599 18.517c-2.545.938-2.944.971-3.178 2.58a12.5 12.5 0 0 0 1.44 1.232c1.371 1.004 4.01 2.34 7.383 2.34h.012v-5.212h-.008c-1.264 0-2.273-.339-3.308-.928-.256-.145-.719.245-.954.07-.325-.24-1.106.208-1.387-.082"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#q)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M10.765 19.293v5.285c.472.056.964.09 1.479.09q.774 0 1.502-.076v-5.264a9 9 0 0 1-1.498.129 7 7 0 0 1-1.483-.165"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: 9.401,
    height: 8.715,
    x: -0.217,
    y: 12.286,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_383_1455",
    stdDeviation: 0.02
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    width: 8.717,
    height: 6.958,
    x: 11.875,
    y: -0.13,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_383_1455",
    stdDeviation: 0.02
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    width: 9.558,
    height: 7.735,
    x: 2.828,
    y: -0.145,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_383_1455",
    stdDeviation: 0.02
  })), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    width: 13.1,
    height: 12.206,
    x: 11.098,
    y: 12.485,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_383_1455",
    stdDeviation: 0.02
  })), /*#__PURE__*/React.createElement("filter", {
    id: "j",
    width: 12.184,
    height: 5.147,
    x: 12.036,
    y: 9.754,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_383_1455",
    stdDeviation: 0.02
  })), /*#__PURE__*/React.createElement("filter", {
    id: "k",
    width: 7.816,
    height: 8.999,
    x: -0.22,
    y: 3.861,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_383_1455",
    stdDeviation: 0.02
  })), /*#__PURE__*/React.createElement("filter", {
    id: "m",
    width: 7.798,
    height: 6.748,
    x: 2.016,
    y: 0.611,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_383_1455",
    stdDeviation: 0.143
  })), /*#__PURE__*/React.createElement("filter", {
    id: "o",
    width: 8.916,
    height: 6.254,
    x: 3.38,
    y: 18.456,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_383_1455",
    stdDeviation: 0.02
  })), /*#__PURE__*/React.createElement("filter", {
    id: "q",
    width: 3.062,
    height: 5.457,
    x: 10.725,
    y: 19.252,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_383_1455",
    stdDeviation: 0.02
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-.49872 -12.1958 17.9311 -.73186 9.031 20.777)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.142,
    stopColor: "#1abd4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "#6ec30d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#8ac502"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366,
    stopColor: "#a2c600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446,
    stopColor: "#c8c903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#ebcb03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#f7cd07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#fdcd04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#fdce05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    stopColor: "#ffce0a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(8.46967 0 0 10.9278 20.215 6.528)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.408,
    stopColor: "#fb4e5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4540"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-11.8666 6.56624 8.91875 16.0877 15.59 -1.687)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#ff4541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#ff4540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#ff4640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#ff473f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#ff5138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#ff5b33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    stopColor: "#ff6c29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8c18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-21.5204 -28.066 -10.3696 7.93625 12.432 23.065)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#0cba65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#0bb86d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#09b479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#08ad93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    stopColor: "#0aa6a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#0d9cc6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#1893dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769,
    stopColor: "#258bf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#3086ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.52295 13.1145 18.1501 2.10376 11.204 2.208)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.366,
    stopColor: "#ff4e3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#ff8a1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#ffa312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#ffb60c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#ffcd0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    stopColor: "#fecf0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915,
    stopColor: "#fecf08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdcd01"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.40212 4.86406 -13.7322 -12.4047 9.062 2.072)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#ff4c3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604,
    stopColor: "#ff692c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#ff7825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#ff8d1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9f13"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "p",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-11.8666 -6.56624 8.91876 -16.0877 15.59 26.176)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#0fbc5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#0fbc5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366,
    stopColor: "#0fbc5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#0fbc5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#12bc58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#28bf3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#38c02b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    stopColor: "#52c218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915,
    stopColor: "#67c30f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86c504"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 10.765,
    x2: 13.746,
    y1: 21.981,
    y2: 21.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0fbc5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0cba65"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleColored);
export default __webpack_public_path__ + "static/media/google_colored.2d472c1df1892786f053a75ddb6e109e.svg";
export { ForwardRef as ReactComponent };